/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-12-06 16:23:31
 */
export const tripStatusEnum = [
  { label: '发起中', value: 1 },
  { label: '待出行', value: 2 },
  { label: '进行中', value: 3 },
  { label: '已完成', value: 4 },
  { label: '已取消', value: 5 },
  { label: '已爽约', value: 6 }
]

export const feedbackTypeEnum = [
  { label: '存在欺诈骗钱行为', value: 1 },
  { label: '发布不适当内容对我造成骚扰', value: 2 },
  { label: '成功', value: 3 },
  { label: '爽约', value: 4 },
  { label: '其它', value: 5 }
]

export const handleResultEnum = [
  { label: '判断为爽约', value: 1 },
  { label: '判断为未爽约', value: 2 }
]

